import { render, staticRenderFns } from "./CuttingNew.vue?vue&type=template&id=25c170e6"
import script from "./CuttingNew.vue?vue&type=script&lang=js"
export * from "./CuttingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports